import { Stack, Group } from "@mantine/core";
import { SubscriptionPlan } from "../Subscriptions";
import PlanCard from "./PlanCard";
import { useBreakpoints } from "../../../utils/useBreakpoints";

type UpgradePlansProps = {
    plans: SubscriptionPlan[],
    loading: { name: string, state: boolean},
    onPress: (selected: SubscriptionPlan) => void
};

const UpgradePlans = (props: UpgradePlansProps) => {
    const { isMobile } = useBreakpoints();
    
    return <>
        <Stack hiddenFrom="sm">
            {   
                props.plans.map((plan, index) => 
                    <PlanCard 
                        plan={ plan } 
                        loading={ props.loading }
                        key={ index } 
                        onPress={ selected => props.onPress(selected) } 
                    />
                )
            }
            <div style={{ height: '50px' }}></div>
        </Stack>

        <Group visibleFrom="sm" gap={ !isMobile ? 50 : 0 }>
            {   
                props.plans.map((plan, index) => 
                    <PlanCard 
                        plan={ plan } 
                        loading={ props.loading }
                        key={ index } 
                        onPress={ selected => props.onPress(selected) } 
                    />
                )
            }
        </Group>
    </>
};

export default UpgradePlans;